import React, { ReactElement } from "react";
import { HypotheekvormData } from "../../../../../../.generated/rapportage/rapportagetypes";
import Table from "../../../../components/Table";
import { Column } from "../../../../components/BaseTable";

export const HypotheekAflossingTable = ({
  hypotheekvormData,
}: {
  hypotheekvormData: (HypotheekvormData & { jaar: number })[];
}): ReactElement => {
  const columns: Column[] = [
    {
      header: "Jaar",
      accessor: "jaar",
    },
    {
      header: "Marktwaarde",
      accessor: "marktwaarde",
      dataType: "currency",
    },
    {
      header: "Hypotheekschuld",
      accessor: "hypotheekschuld",
      dataType: "currency",
    },
    {
      header: "Schuldverhouding",
      accessor: "schuldverhouding",
      dataType: "percentage",
    },
    {
      header: "Rente percentage",
      accessor: "rentepercentage",
      dataType: "percentage",
    },
    {
      header: "Bruto maandlast",
      accessor: "brutoMaandlast",
      dataType: "currency",
    },
    {
      header: "Netto maandlast",
      accessor: "nettoMaandlast",
      dataType: "currency",
    },
  ];

  return (
    <>
      {hypotheekvormData?.length > 0 && (
        <Table
          data={hypotheekvormData}
          columns={columns}
          id="hypotheek-aflossing-table"
        />
      )}
    </>
  );
};
